export default __webpack_public_path__ + "static/media/logo_grey.abb7251d.svg";